<template>
  <v-app :dark="darkMode"  v-if="fontFamily" id="inspire" :style="'--fontFamily: ' + fontFamily.value">
    <v-container class="pa-0">
      <!-- Header -->
      <AppHeader></AppHeader>
      <!-- Content -->
      <v-content>
        <router-view class></router-view>
      </v-content>
      <!-- Footer -->
    </v-container>
    <AppFooter></AppFooter>
  </v-app>
</template>
<script>
import i18n from "@/i18n";
import AppHeader from "../components/layout/Header";
import AppFooter from "../components/layout/company/Footer";
import { mapGetters } from "vuex";
export default {
  name: "GuestLayout",
  metaInfo() {
    return {
      title: "Movies Everywhere",
      titleTemplate: "%s | Screener",
      link: [{ rel: "icon", href: "favicon.ico" }],
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "A virtual and hybrid cinema for organizations",
        },
        {
          property: "og:title",
          content: "Movies Everywhere",
          template: (chunk) => `${chunk} | Home`,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: "A virtual and hybrid cinema for organizations",
          vmid: "og:description",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:site_name",
          content: "Movies Everywhere",
          vmid: "og:site_name",
        },
      ],
    };
  },
  components: {
    AppHeader,
    AppFooter,
  },
  mounted(){
    this.loadFonts();
  },
  computed: {
    ...mapGetters("app", {
      darkMode: "darkMode",
      fontFamily : "fontFamily"
    }),
  },
  watch: {
    fontFamily: {
      deep: true,
      handler:function(){
        this.loadFonts();
      },
    },
  },
  methods: {
    loadFonts(){
      var _this = this;
      var junction_font = new FontFace(this.fontFamily.value, `url(${this.fontFamily.url})`);
        junction_font.load().then(function(loaded_face) {
          document.fonts.add(loaded_face);
            document.body.style.fontFamily = _this.fontFamily.value;
        }).catch(function(error) {
      });
    },
  }
};
</script>
<style>
#inspire {
  font-family: var(--FontFamily) !important;
}
</style>